import { defineComponent as _defineComponent } from 'vue'
import FormContainer from '@/components/molecules/form/FormContainer.vue';
import { SelectInputData } from '@/components/molecules/input/types';
import PageHeader from '@/components/molecules/page/header/PageHeader.vue';
import { computed, getCurrentInstance, onMounted, reactive } from 'vue';
import NewRequestStepper from '../common/stepper/NewRequestStepper.vue';

type NewRequestSelectBranchState = {
  isLoading: boolean;
  branches: any[];
}

type NewRequestSelectBranchForm = {
  branch: SelectInputData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRequestSelectBranch',
  setup(__props) {

const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;

const title = 'Crear solicitud';

const state = reactive<NewRequestSelectBranchState>({
  isLoading: false,
  branches: null,
});

const form = reactive<NewRequestSelectBranchForm>({
  branch: {
    type: "select",
    options: [],
    value: 0,
    label: "Seleccionar ramos",
    col: 12
  },
});

const formFields = computed(() => {
  const fieldsToReturn = {};

  Object.keys(form).forEach((key: string) => {
    if (form[key]) {
      fieldsToReturn[key] = form[key];
    }
  });

  return fieldsToReturn;
});

const fillFields = () => {
  if (!state.branches) return null;

  form.branch = {
    ...form.branch,
    options: state.branches.map(branch => ({ id: branch.id, value: branch.id, label: branch.title })),
    value: state.branches[0].id,
  };
};

const loadCompanyBranches = async () => {
  let companyId = proxy.$store.state.companyId;
  const response: any = await proxy.$root._get(`companies/${companyId}/branches`);
  state.branches = response;

}

const nextStep = (id?: string) => {
  const selected = state.branches.find(branch => branch.id === (id || form.branch.value));
  proxy.$store.commit('setNewRequestBranch', selected);
  proxy.$router.push('/requests/new/conditions');
};

const getFormActions = () => [
  {
    label: "Siguiente",
    disabled: form.branch.value === null,
    onClick: () => nextStep()
  }
];

onMounted(async () => {
  state.isLoading = true;
  proxy.$store.commit('clearNewRequest', false);
  await Promise.all([
    loadCompanyBranches(),
  ]);
  fillFields();
  state.isLoading = false;
  if(state.branches.length === 1) {
    nextStep(state.branches[0].id);
  }
});

return { __sfc: true,instance, proxy, title, state, form, formFields, fillFields, loadCompanyBranches, nextStep, getFormActions, FormContainer, PageHeader, NewRequestStepper }
}

})